export default __webpack_public_path__ + "static/media/influencer.c85062e3.png";